export function removeRepr (comp, type) {
  if (hasRepr(comp, type)) {
    let repr = getRepr(comp, type)
    comp.removeRepresentation(repr)
  }
}

export function hasRepr (comp, name) {
  return comp.reprList.filter(repr => repr.name === name).length
}

export function getRepr (comp, name) {
  return comp.reprList.find(repr => repr.name === name)
}
